module.exports = __webpack_public_path__ + "img/pin-2004.1510cc12.png";